const $inject = [];

const hotelRatingProviderService = function () {
  let service = {};

  service.get = function get() {
    return require("json!../static/hotel-rating-provider.json");
  };

  return service;
};

hotelRatingProviderService.$inject = $inject;

export default hotelRatingProviderService;


// WEBPACK FOOTER //
// ./src/services/hotelRatingProviderService.js